<template>
    <v-dialog
        v-model="dialog"  
        persistent 
        max-width="650px"
        transition="dialog-transition">
        <template v-slot:activator="{ on:dialog }">
            <v-tooltip top>
                <template v-slot:activator="{ on:tooltip }">
                    <v-icon v-on="{ ...tooltip, ...dialog }" color="#0B3F67">mdi-cloud-upload</v-icon>                    
                </template>
                {{ tooltipText }}
            </v-tooltip>
        </template>
        <v-card :loading="loading">
            <v-card-title class="pa-0">
              <ModalTitle :titulo="titulo" @cancelar="cancelar"/>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-col cols="12" class="pt-3 pb-0" >
                    <div class="d-flex justify-space-stretch">
                        <div class="file-width pr-2 overflow-x-hidden ">
                           <v-file-input 
                                v-if="!fromRepoDoc"
                                accept=".png, .jpg, .jpeg"
                                show-size 
                                counter  
                                multiple
                                v-model="archivos" 
                                :label="label"
                                :error-messages="docErrors"
                                @change="$v.archivos.$touch()"
                                @blur="$v.archivos.$touch()">
                            </v-file-input>
                            <RepoNameDocs v-else :docs="repoDoc" />
                        </div>
                        <div class="d-flex align-center">
                            <CargarDesdeRepositorio 
                                titulo="Repositorio" 
                                origen="actividadCompensacion" 
                                :anioConsulta="anioConsulta" 
                                :singleSelect="false"
                                v-model="repoDoc"
                                :notSelectable="notSelect"
                                :tipo="tipoRepo"
                            />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0" v-if="(labels!= undefined && labels.length >= 1)">
                    <div class="d-flex justify-space-stretch">
                        <div class="file-width pr-2 overflow-x-hidden ">
                            <v-file-input 
                                v-if="!fromRepoDocDos"
                                accept=".png, .jpg, .jpeg"
                                show-size 
                                counter  
                                multiple
                                v-model="archivoDos" 
                                :label="labels[0]"
                                :error-messages="evidDosErrors"
                                @change="$v.archivoDos.$touch()"
                                @blur="$v.archivoDos.$touch()">
                            </v-file-input>
                            <RepoNameDocs v-else :docs="repoDocDos" />
                        </div>
                        <div class="d-flex align-center">
                            <CargarDesdeRepositorio 
                                titulo="Repositorio" 
                                origen="actividadCompensacion" 
                                :anioConsulta="anioConsulta" 
                                :singleSelect="false"
                                v-model="repoDocDos"
                                :notSelectable="notSelectDos"
                                :tipo="tipoRepo"
                            />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0" v-if="(labels!= undefined && labels.length >= 2)">
                    <div class="d-flex justify-space-stretch">
                        <div class="file-width pr-2 overflow-x-hidden ">
                            <v-file-input 
                                v-if="!fromRepoDocTres"
                                accept=".png, .jpeg, .jpg"
                                show-size 
                                counter 
                                multiple 
                                v-model="archivoTres"
                                :error-messages="evidTresErrors"
                                @change="$v.archivoTres.$touch()"
                                @blur="$v.archivoTres.$touch()"
                                :label="labels[1]">
                            </v-file-input>    
                            <RepoNameDocs v-else :docs="repoDocTres" />
                        </div>
                        <div class="d-flex align-center">
                            <CargarDesdeRepositorio 
                                titulo="Repositorio" 
                                origen="actividadCompensacion" 
                                :anioConsulta="anioConsulta" 
                                :singleSelect="false"
                                v-model="repoDocTres"
                                :notSelectable="notSelectTres"
                                :tipo="tipoRepo"
                            />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0" v-if="(labels!= undefined && labels.length >= 3)">
                    <div class="d-flex justify-space-stretch">
                        <div class="file-width pr-2 overflow-x-hidden ">
                            <v-file-input 
                                v-if="!fromRepoDocCuat"
                                accept=".png, .jpeg, .jpg"
                                show-size 
                                counter 
                                multiple 
                                v-model="archivoCuat"
                                :error-messages="evidCuatErrors"
                                @change="$v.archivoCuat.$touch()"
                                @blur="$v.archivoCuat.$touch()"
                                :label="labels[2]">
                            </v-file-input>  
                            <RepoNameDocs v-else :docs="repoDocCuat" />
                        </div>
                        <div class="d-flex align-center">
                            <CargarDesdeRepositorio 
                                titulo="Repositorio" 
                                origen="actividadCompensacion" 
                                :anioConsulta="anioConsulta" 
                                :singleSelect="false"
                                v-model="repoDocCuat"
                                :notSelectable="notSelectCuat"
                                :tipo="tipoRepo"
                            />
                        </div>
                    </div>
                </v-col>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" :disabled="loading" @click="cancelar" text>Cancelar</v-btn>
                <v-btn color="#0B3F67" :disabled="disabled" :loading="loading" @click="argregarEvidencias" text>Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import RepoNameDocs from "@/components/documentos/RepoNameDocs.vue"
import CargarDesdeRepositorio from "@/components/documentos/CargarDesdeRepositorio.vue"
import ModalTitle from '@/components/utils/ModalTitleComponent'
import axios from "@/axios.js";
//Custom validations
const maxFileSize = (files) => {
    if(files != null) {
        let maximo = files.length * (5 * 1024 * 1024);
        let total = 0;
        files.forEach(file => {
            total += file.size
        });        
        return total <= maximo;
    }
    return true;
}
export default {
    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },
    components: {
      ModalTitle,
      RepoNameDocs,
      CargarDesdeRepositorio
    },
    props: [
        'id',
        'url',//url del request para cargar las evidencias
        'titulo',
        'tooltipText',
        'tituloBtn',
        'origen',
        'icon',
        'label',//label del file input principal
        'labels',// (Array de)labels de los otros file inputs (los inputs se activan dependiendo la cantidad de label ingresadas)
        'tipoRepo'
    ],
    computed: {
        fileSize() {
            return this.archivos != null ? this.archivos.length : 0;
        },
        fileDosSize() {
            return this.archivoDos != null ? this.archivoDos.length : 0;
        },
        fileTresSize() {
            return this.archivoTres != null ? this.archivoTres.length : 0;
        },
        fileCuatSize() {
            return this.archivoCuat != null ? this.archivoCuat.length : 0;
        },
        sucursal() {
            return this.$store.getters.sucursal;
        },
        indicadorActual() {
            return this.$store.getters.indicadorActual;
        },
        usuario(){
            return this.$store.getters.usuario;
        },
        anioConsulta() {
            return this. $store.getters.anioConsulta;
        },
        docErrors () {
            const errors = []
            if (!this.$v.archivos.$dirty) return errors            
            !this.$v.archivos.maxFileSize && errors.push('El tamaño total debe ser menor a ' + this.fileSize + ' MB.')        
            return errors
        },
        evidDosErrors() {
            const errors = []
            if (!this.$v.archivoDos.$dirty) return errors            
            !this.$v.archivoAct.maxFileSize && errors.push('El tamaño total debe ser menor a ' + this.fileDosSize + 'MB.')
            return errors
        },
        evidTresErrors() {
            const errors = []
            if (!this.$v.archivoTres.$dirty) return errors            
            !this.$v.archivoPart.maxFileSize && errors.push('El tamaño total debe ser menor a ' + this.fileTresSize + 'MB.')
            return errors
        },
        evidCuatErrors() {
            const errors = []
            if (!this.$v.archivoCuat.$dirty) return errors            
            !this.$v.archivoCuat.maxFileSize && errors.push('El tamaño total debe ser menor a ' + this.fileCuatSize + 'MB.')
            return errors
        },
        fromRepoDoc() {
            return this.repoDoc.length > 0
        },
        fromRepoDocDos() {
            return this.repoDocDos.length > 0
        },
        fromRepoDocTres() {
            return this.repoDocTres.length > 0
        },
        fromRepoDocCuat() {
            return this.repoDocCuat.length > 0
        },
        notSelect() {
            return [...this.repoDocDos, ...this.repoDocTres, ...this.repoDocCuat].map(obj => obj.repositorioId);
        },
        notSelectDos() {
            return [...this.repoDoc, ...this.repoDocTres, ...this.repoDocCuat].map(obj => obj.repositorioId);
        },
        notSelectTres() {
            return [...this.repoDocDos, ...this.repoDoc, ...this.repoDocCuat].map(obj => obj.repositorioId);
        },
        notSelectCuat() {
            return [...this.repoDocDos, ...this.repoDocTres, ...this.repoDoc].map(obj => obj.repositorioId);
        },
        disabled() {
            return (!this.archivos.length && !this.archivoDos.length && !this.archivoTres.length && !this.archivoCuat.length) &&
                   (!this.repoDoc.length && !this.repoDocDos.length && !this.repoDocTres.length && !this.repoDocCuat.length)
        }
    },
    data: () => ({
        dialog : false,
        loading: false,
        archivos: [],
        archivoDos: [],
        archivoTres: [],
        archivoCuat: [],
        //
        repoDoc: [],
        repoDocDos: [],
        repoDocTres: [],
        repoDocCuat: [],
    }),
    validations: {
        archivos: {
            maxFileSize
        },
        archivoDos: {
            maxFileSize
        },
        archivoTres: {
            maxFileSize
        },
        archivoCuat: {
            maxFileSize
        }
    },
    methods: {
        argregarEvidencias() {
            this.$v.$touch();
            if(!this.$v.$invalid) {
                this.loading = true;
                let formData = this.requestFormdata()
                axios.post(this.url, formData)
                .then(() => {
                    this.efectivo('Evidencias agregadas');
                }).catch(error => {
                    if (error.request && error.request.status === 401) {
                        this.$store.commit('showSessionDialog', true);
                    } else {
                        if (error.request && error.request.status === 415) {
                            this.$store.dispatch('noti', {mensaje: error.response.data, color: 'error'});
                            this.loading = false;
                        } else {  
                            this.erroneo(error, 'agregaron las evidencias');
                        }
                    }
                })
            }
        },

        efectivo(str) {
            this.$store.dispatch('noti',{mensaje: str, color:'success'});
            this.$emit('reload');
            this.cancelar();
        },

        erroneo(error, str){
            console.log("Error en la carga de documentos " + error);
            this.$store.dispatch('noti', {mensaje: 'Ocurrió un error no se ' + str, color:'error'}); 
            this.cancelar();
        },

        requestFormdata() {
            let formData = new FormData();
            formData.append('id', this.id);
            formData.append('origen', this.origen);
            formData.append('anio', this.anioActual);
            formData.append('idUsuario', this.usuario.id);
            formData.append('indicador', this.indicadorActual);
            formData.append('idInstalacion', this.sucursal.id);
            //archivos normales
            if(this.archivos.length > 0) {
                this.archivos.forEach(file => {
                    formData.append('archivos', file);
                });
            }
            if(this.archivoDos.length > 0) {
                this.archivoDos.forEach(file => {
                    formData.append('archivosOpt', file);
                });
            }
            if(this.archivoTres.length > 0) {
                this.archivoTres.forEach(file => {
                    formData.append('archivosOptUn', file);
                });
            }
            if(this.archivoCuat.length > 0) {
                this.archivoCuat.forEach(file => {
                    formData.append('archivosOptDo', file);
                });
            }
            //archivos de repositorio
            if(this.repoDoc.length > 0) {
                this.repoDoc.forEach(doc => {
                    formData.append('evidRepo', JSON.stringify(doc.repositorioId));
                });
            }
            if(this.repoDocDos.length > 0) {
                this.repoDocDos.forEach(doc => {
                    formData.append('evidRepoDos', JSON.stringify(doc.repositorioId));
                });
            }
            if(this.repoDocTres.length > 0) {
                this.repoDocTres.forEach(doc => {
                    formData.append('evidRepoTres', JSON.stringify(doc.repositorioId));
                });
            }
            if(this.repoDocCuat.length > 0) {
                this.repoDocCuat.forEach(doc => {
                    formData.append('evidRepoCuat', JSON.stringify(doc.repositorioId));
                });
            }

            return formData;
        },

        cancelar() {
            this.archivos = [];
            this.$v.archivos.$reset();
            this.archivoDos = []
            this.archivoTres = []
            this.archivoCuat = []
            this.repoDoc = []
            this.repoDocDos = []
            this.repoDocTres = []
            this.repoDocCuat = []
            this.dialog = false;
            this.loading = false;
        }
    },
}
</script>
<style scoped>
    .file-width {
        width: 100%;
    }
</style>